import * as React from "react";
import {Loader} from "../../../components/Utils/loader/Loader";
import {Popup} from "../dashboard/lavazza/components/popup/Popup";
import {PredefinedSize, SectionModel} from "./builder/models";
import {LoadableSection} from "./components/LoadableSection";
import {EquipmentSettingsPopupController, EquipmentSettingsService} from "./EquipmentSettingsService";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../../index";

import "./EquipmentSettings.scss";

export interface EquipmentSettingsInterface {
    visibilityToggle: (isVisible: boolean, callback?) => void;
}

interface EquipmentSettingsProps {
    equipmentID: string;
    onComponentMount?: (panelInterface: EquipmentSettingsInterface) => void;
    onSectionMount?: (sectionID: string) => void;
}

interface EquipmentSettingsState {
    sections: SectionModel[];
    isVisible: boolean;
    isLoading: boolean;
}

export class EquipmentSettings extends React.Component<EquipmentSettingsProps, EquipmentSettingsState> {

    private panelInterface: EquipmentSettingsInterface;

    constructor(props) {
        super(props);

        this.state = {
            sections: [],
            isVisible: true,
            isLoading: true,
        };
    }

    public componentDidMount() {
        EquipmentSettingsService.getEquipmentSettingsSections(this.props.equipmentID)
            .then((equipmentData) => {
                this.setState({sections: equipmentData.settingSections, isLoading: false});
            })
            .catch(console.error);

        this.panelInterface = {
            visibilityToggle: (isVisible: boolean, callback?) => {
                this.setState({isVisible}, () => {
                    if (this.state.isVisible) {
                        EquipmentSettingsService.getEquipmentSettingsSections(this.props.equipmentID)
                            .then((equipmentData) => {
                                this.setState(
                                    {sections: equipmentData.settingSections},
                                    () => {
                                        if (callback) {
                                            callback();
                                        }
                                    },
                                );
                            })
                            .catch(console.error);
                    }
                });
            },
        };

        this.props.onComponentMount(this.panelInterface);
    }

    public reloadSections = () => {
        this.setState({...this.state, isLoading: true})
        EquipmentSettingsService.getEquipmentSettingsSections(this.props.equipmentID)
            .then((equipmentData) => {
                this.setState({sections: equipmentData.settingSections, isLoading: false});
            })
            .catch(console.error);
    }

    public componentWillUnmount() {
        if (this.panelInterface) {
            this.panelInterface.visibilityToggle = undefined;
        }
    }

    public render() {
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                <div
                    className={"EquipmentSettings"}
                >
                    {this.state.isLoading
                        ? <Loader/>
                        : this.state.isVisible
                            ? <>
                                <div className={"wrapper"}>
                                    {this.buildPage()}
                                </div>
                                <Popup controller={EquipmentSettingsPopupController}/>
                            </>
                            : null
                    }
                </div>
            </ThemeProvider>
        );
    }

    private buildPage = () => {
        const result = [];
        for (let i = 0; i < this.state.sections.length; i++) {
            if (
                this.state.sections[i].sizeRatio === PredefinedSize.HALF
                && (i + 1 < this.state.sections.length && this.state.sections[i + 1].sizeRatio === PredefinedSize.HALF)
            ) {
                result.push((
                    <div
                        className={"Row"}
                        key={
                            this.state.sections[i].name + i
                            + this.state.sections[i + 1].name + (i + 1)
                        }
                    >
                        <LoadableSection
                            className={"HALF"}
                            sectionInfo={this.state.sections[i]}
                            onLoaded={this.props.onSectionMount}
                            reloadSections={this.reloadSections}
                        />
                        <LoadableSection
                            className={"HALF"}
                            sectionInfo={this.state.sections[i + 1]}
                            onLoaded={this.props.onSectionMount}
                            reloadSections={this.reloadSections}
                        />
                    </div>
                ));
                i += 1;
            } else {
                result.push((
                    <div
                        className={"Row"}
                        key={"row-" + this.state.sections[i].name + i}
                    >
                        <LoadableSection
                            className={"FULL"}
                            sectionInfo={this.state.sections[i]}
                            key={this.state.sections[i].name + i}
                            onLoaded={this.props.onSectionMount}
                            reloadSections={this.reloadSections}
                        />
                    </div>
                ));
            }
        }
        return result;
    }
}
